import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "../../API/axios";
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
import WcOutlinedIcon from '@mui/icons-material/WcOutlined';
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { PlaceSharp } from "@mui/icons-material";


const UserResume = () => {


	const navigate = useNavigate();
	const { cnddtUID } = useParams();
	const sessionId = localStorage.getItem("sessionId");

	const [userData, setUserData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [profileChecked, setProfileChecked] = useState(false); // New state to prevent infinite loop
	console.log("userData", userData);

	const getUserDetail = () => {
		setLoading(true);
		axios
			.get(`/Candidate/GetProfile?UID=${cnddtUID}`)
			.then((response) => {
				setUserData(response.data.responseData);
				setProfileChecked(false); // Mark as checked
			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					getUserBasicDetails(); // Call Basic Details if Profile not found
				} else {
					console.log(error);
				}
			})
			.finally(() => setLoading(false));
	};

	const getUserBasicDetails = () => {
		setLoading(true);
		axios
			.get(`/Candidate/GetBasicProfile?UID=${cnddtUID}`)
			.then((response) => {
				const res = response.data.responseData;
				setUserData(res);
			})
			.catch((error) => console.log(error))
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		getUserDetail();
	}, []); // Run once on mount

	console.log("userData", userData);



	//************************ Block Company Start  ************************//
	const [showModal, setShowModal] = useState(false);
	const handleShowModal = () => setShowModal(true);
	const handlecloseModal = () => setShowModal(false);

	const BlockCompany = async () => {
		const data = {
			sessionId: sessionId,
		};
		try {
			await axios.post(`/Company/BlockCandidate?UID=${cnddtUID}`, data)
				.then((resData) => {
					console.log("Block Company", resData.data.message);
					toast.success(resData.data.message);
					getUserDetail()
					handlecloseModal()
				});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
				handlecloseModal()

			} else {
				toast.error(e.response.data.message);
			}
		}
	};

	const handleConfirmBlock = () => {
		BlockCompany();
		// setShowModal(false)

	};

	//************************ Block Company End  ************************//

	//************************ UnBlock Company Start  ************************//

	const UnBlockCompany = async () => {
		const data = {
			sessionId: sessionId,
			//    compUID: Compuid,
		};
		//    console.log("session ids", sessionId, Compuid);

		try {
			await axios.post(`/Company/UnblockCandidate?UID=${cnddtUID}`, data)
				.then((resData) => {
					console.log("Block Company", resData.data.message);
					toast.success(resData.data.message);
					getUserDetail()
				});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	//************************ UnBlock Company End  ************************//

	// handleClickView to Resume ViewResume
	const handleClickView = () => {
		const isInstitution = userData?.insttCandidateProfile !== null
		const cnddtUID = userData?.cnddtUID;
		const instnCnddtId = userData?.insttCandidateProfile?.instnCnddtId;

		const url = isInstitution
			? `/Resume?userUID=${cnddtUID}&InstnCnddtId=${instnCnddtId}`
			: `/Resume/Candidate?userUID=${cnddtUID}`;

		navigate(url); // Only one navigation push
	};



	return (
		<>
			{userData &&
				<div className="container">
					<div className="profile-resume-main-container pt-2">
						<div className="title delete-title d-flex justify-content-between align-items-center Title-header-Mobile post-new-job-title">
							<h1 className="orange-title">
								<span className="orange-box"></span> Profile
							</h1>
						</div>
						<div class="job-archive-footer">
							{userData.hasValidCnddtPrf === true ? (""
							) : (
								<div to="#"
									class="tf-btn complete-profile-Btn  mb-2"
								>
									Profile Incomplete
								</div>
							)}
						</div>
						{loading ? (
							<div className="row mt-4">
								<div className="col-md-12 d-flex justify-content-center">
									<p>Candidate not found</p>
									{/* <ShimmerDiv mode="light" height={100} width={'100%'} />   */}
								</div>
							</div>
						) : <>
							<div className="profile-resume-userinfo mb-3">
								<div className="row pt-4 pb-4 align-center">
									<div className="col-md-3 col-lg-2">
										<div className="profile-resume-image d-flex justify-content-center">
											<img src={userData.profileImage} alt="" srcset="" width={"120px"} style={{ borderRadius: "50%", height: "120px" }} />
										</div>
									</div>
									<div className="col-md-6 col-lg-8">
										{userData?.candidateProfileInfo?.headLine === null ? '' : (
											<div className="profile-resume-designation f-14 f-600">
												{userData?.candidateProfileInfo?.headLine}
											</div>
										)}
										<div className="d-flex align-items-center mb-1 Main-resume-username">
											<div className="profile-resume-username me-2">
												{userData.firstName} {userData.lastName}
											</div>

										</div>
										<div className="d-flex Resume-Skills-Country-Mobile">

											<div className="profile-resume-country d-flex align-items-center">
												{userData.cityName === "" || userData.cityName === null ? '' : (

													<div className="profile-resume-country-icon d-flex  align-item-center me-3 f-18  f-400">
														<span class="icon-map-pin me-2"></span>
														{userData.cityName}
													</div>
												)}

											</div>


										</div>
									</div>
									<div className="col-md-2 col-lg-2 Manage-Download-Mobile d-flex flex-column align-center">

										{userData.hasValidCnddtPrf === false ? "" : (
											<>
												{/* <div className="edit-profile-btn" onClick={handleClickView} style={{ cursor: 'pointer' }}>
													{userData?.insttCandidateProfile !== null ?
														<Button className="f-13 mt-2" style={{ width: '125px' }}>
															<Link to={`/Resume?userUID=${userData?.cnddtUID}&InstnCnddtId=${userData?.insttCandidateProfile?.instnCnddtId}`} style={{ fontWeight: 'normal' }}>

																View Resume
															</Link>
														</Button>
														: (
															<>
																<Button className="f-13 mt-2" style={{ width: '125px' }}>
																	<Link
																		to={`/Resume/Candidate?userUID=${userData?.cnddtUID}`}
																		style={{ fontWeight: 'normal' }}>
																		View Resume
																	</Link>
																</Button>
															</>
														)
													}

												</div> */}
												<div className="edit-profile-btn" onClick={handleClickView} style={{ cursor: 'pointer' }}>
													<Button className="f-13 mt-2" style={{ width: '125px' }}>
														View Resume
													</Button>
												</div>

											</>
										)}
										{userData.isBlockedByComp === true ? (
											<div className="edit-profile-btn  ">
												<Button onClick={() => {
													UnBlockCompany()
												}}
													className="f-13 mt-2" style={{ width: '125px' }}>
													Unblock
												</Button>
											</div>
										) : (
											<div className="edit-profile-btn  ">
												<Button
													onClick={() => {
														handleShowModal()
													}}
													className="f-13 mt-2" style={{ width: '125px' }}>
													Block
												</Button>
											</div>
										)}
									</div>
								</div>
							</div>

							<div className="row justify-content-center">
								<div className="col-lg-4">

									<div className="cv-form-details po-sticky job-sg single-stick email-cv-form-details profile-resume-userinfo ">
										<ul className="list-infor email-list-infor p-0 mb-0">
											{/* email */}
											{
												userData.email ?
													<div className="content personal-info mt-2">
														<div className="d-flex align-end">
															<AttachEmailSharpIcon className="me-2" />
															{/* <p className='mb-0 pb-0'>{userData.email}</p> */}
															<a href={`mailto:${userData.email}`}
																onClick={(e) => {
																	if (!userData.email) {
																		e.preventDefault();
																		alert("Email is not available!");
																	}
																}}
															>
																{userData.email}
															</a>
														</div>
													</div>
													: ""
											}

											{userData?.phoneNumber === null ? (
												<div className="content  mt-2">
													<div className="d-flex f-14">

														<LocalPhoneIcon className="me-2" /> <p className='mb-0'>
															Not Provided
														</p>
													</div>
												</div>

											) : (
												<div className="content  mt-2">
													<div className="d-flex f-14">

														<LocalPhoneIcon className="me-2" /> <p className='mb-0'>
															{userData.phoneNumber}
														</p>
													</div>
												</div>
											)}

											{/* Dob */}
											{
												userData.dob ?
													<div className="content  mt-2">
														<div className="d-flex align-end">
															{/* <CalendarMonthSharpIcon className="me-2" /> <p className='mb-0'>{userData.dob}</p> */}
															<CalendarMonthSharpIcon className="me-2" /> <p className='mb-0'>
																{moment(userData.dob).format("DD MMM YYYY")}
															</p>
														</div>

													</div> : ""
											}

											{/* WebSite */}
											{
												userData?.candidateProfileInfo?.website ?
													<div className="content  mt-2">
														<div className="d-flex align-end">
															<LinkSharpIcon className="me-2" /> <p className='mb-0'>
																{/* {userData?.candidateProfileInfo?.website} */}
																<a
																	href={userData?.candidateProfileInfo?.website ? userData?.candidateProfileInfo?.website.startsWith("http") ? userData?.candidateProfileInfo?.website : `https://${userData?.candidateProfileInfo?.website}` : "#"}
																	onClick={(e) => {
																		if (!userData?.candidateProfileInfo?.website) {
																			e.preventDefault();
																			alert("Website is not available!");
																		}
																	}}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	{userData?.candidateProfileInfo?.website || "N.A."}
																</a>
															</p>
														</div>
													</div>
													: ""
											}


											{/* Gender */}
											{
												userData.genderName === null ? "" :
													<div className="content  mt-2">
														<div className="d-flex align-end">
															<WcOutlinedIcon className="me-2" /> <p className='mb-0'>{userData.genderName}</p>
														</div>
													</div>
											}
											{/* Internet */}
											<div className="content  mt-2">
												<div className="d-flex align-end">
													<LanguageSharpIcon className="me-2" /> <p className='mb-0'>{userData.langName || "N.A."}</p>
												</div>
											</div>
	{
												userData.phoneNumber === null ? "" :
													<div className="content  mt-2">
														<div className="d-flex align-end">
															<PlaceSharp className="me-2" /> <p className='mb-0'>{userData?.candidateProfileInfo?.address || "N.A"}</p>
														</div>
													</div>
											}

										</ul>
									</div>
								</div>
								{/* {userData?.candidateProfileInfo?.about === null ? "" : ( */}

								<div className="col-lg-8 Aboutme-Container-Profile">
									<div className="profile-resume-parent-cont p-4 rounded-3">

										{!userData?.candidateProfileInfo?.about ? null : (
											<div className="profile-resume-about">
												<div className="profile-resume-about-info">
													<h5 className="f-600">About</h5>
													<p>{userData?.candidateProfileInfo?.about}</p>
												</div>
											</div>
										)}

										{userData?.candidateProfileInfo === null ? "" :
											(
												<div className="content mt-2">
													<div className="d-flex align-end">
														<p className='mb-0'>
															<strong>Active As :</strong> {userData?.candidateProfileInfo?.activeAsName}
														</p>
													</div>
												</div>
											)}

										{userData?.candidateProfileInfo === null ? "" :
											(<>
												<div className="content mt-2">
													<div className="d-flex align-end">
														<p className='mb-0'>
															<strong>Designation :</strong> {userData?.candidateProfileInfo?.designation || "N.A."}</p>
													</div>
												</div>
											</>)}
										{userData?.candidateProfileInfo === null ? "" :
											(<>

												<div className="content mt-2">
													<div className="d-flex align-end">
														<p className='mb-0'>
															<strong>Organization :</strong> {userData?.candidateProfileInfo?.orgName || "N.A."}</p>
													</div>
												</div>
											</>)}


										{userData?.candidateProfileInfo === null ? "" :
											(<>
												<div className="content mt-2">
													<div className="d-flex align-end">
														<p className='mb-0'>
															<strong>Organization Type :</strong> {userData?.candidateProfileInfo?.orgTypeName || "N.A."}</p>
													</div>
												</div>
											</>)}


										{userData?.insttCandidateProfile === null ? "" :
											(<>
												<div className="content mt-2">
													<div className="d-flex align-end">
														<p className='mb-0'>
															<strong>Institute Class :</strong> {userData?.insttCandidateProfile?.insttClssName || "N.A."}</p>
													</div>
												</div>
											</>)}

										{userData?.insttCandidateProfile === null ? "" :
											(<>
												<div className="content mt-2">
													<div className="d-flex align-end">
														<p className='mb-0'>
															<strong>Institute Batch :</strong> {userData?.insttCandidateProfile?.batchNames?.join(" , ") || "N.A."}</p>
													</div>
												</div>
											</>)}


									</div>

								</div>

								{/* )} */}
							</div>
						</>
						}

					</div>
				</div>
			}


			{/* ...............block modal............  */}
			<Modal show={showModal} onHide={handlecloseModal} centered>
				<Modal.Header>
					<Modal.Title>Confirm Block</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handlecloseModal} />
				</Modal.Header>
				<Modal.Body className="settings">
					<div className=" mb-3">
						<p>Are you sure you want to block Candidate</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button onClick={handleConfirmBlock} className="btn btn-danger me-2">Confirm</button>
					{/* <button onClick={handleClose} className="btn btn-secondary">Cancel</button> */}

				</Modal.Footer>

			</Modal>

		</>
	);
};

export default UserResume;
